import React from 'react';

const stepOne = ({ email, setEmail, emailError, submitError, handleVerifyEmail, isLoading }: any) => {
  return (
    <div>
      <label className="zs-label zs-label-required">Email</label>
      <input
        type="email"
        placeholder="email@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        aria-invalid={emailError ? true : undefined}
        className="zs-input h-11"
      />
      {emailError && <p className="zs-error">{emailError}</p>}
      {submitError && <p className="zs-error">{submitError}</p>}
      <button
        onClick={handleVerifyEmail}
        className="mt-5 zs-btn zs-btn-primary zs-btn-lg zs-btn-block"
        disabled={isLoading}
      >
        {isLoading ? "Sending Otp..." : "Claim My Reward"}
      </button>
    </div>
  );
};

export default stepOne;
